import { ADICIONAR_FILTRO_ITINERARIO_EMBARQUE } from '../types'

export default function adicionarItinerarioEmbarque (filtro) {
  return {
    type: ADICIONAR_FILTRO_ITINERARIO_EMBARQUE,
    payload: filtro
  }
}
